<template>
    <page :centered="false">
        <template #title>{{$t('pages.dashboard.service.objects.edit.title')}}</template>

        <template #content-template>
            <div class="container">
                <m-stepper-object-edit v-if="objectLoaded"/>
            </div>
        </template>
    </page>
</template>

<script>
    import breadcrumbs from "@mixins/helpers/_breadcrumbs";
    import {mapActions, mapGetters} from 'vuex'
    import Page from "@pages/templates/page";
    import MStepperObjectEdit from "@modules/steppers/concrete/m-stepper-object-edit";
    import vuexKeys from "@mixins/includes/_vuexKeys";
    import errorHandler from "@mixins/responses/_errorHandler";
    import notifications from "@mixins/includes/_notifications";

    export default {
        name: "dashboard-service-objects-edit",
        mixins: [breadcrumbs, vuexKeys, errorHandler, notifications],
        components: {Page, MStepperObjectEdit},
        metaInfo() {
            return {
                title: this.$t('pages.dashboard.service.objects.edit.meta.title')
            }
        },
        async created() {
            try {
                await this.requestObject();
            } catch (e) {
                this.error.handle(e)
            }
            this.$iBreadcrumbs.setParentText(this.object.name);
        },
        computed: {
            ...mapGetters({
                getObject: 'objects/read'
            }),
            object() {
                return this.getObject(this.$route.params.id)
            },
            objectLoaded() {
                return Object.keys(this.object).length > 0
            }
        },
        methods: {
            ...mapActions({
                loadObject: 'objects/read'
            }),
            async requestObject() {
                await this.loadObject({id: this.$route.params.id})
            }
        }

    }
</script>

<style scoped>
</style>
